import React from "react";
import styles from "./index.module.scss";
import { Sidebar } from "primereact/sidebar";
import NotificationBody from "../notification-body";

export default function NotificationMobileSidebar({
  showModel,
  setShowModel
}: {
  showModel: boolean;
  setShowModel: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return (
    <Sidebar
      visible={showModel}
      position="bottom"
      onHide={() => setShowModel(false)}
      className={styles.NotificationModel}
      maskClassName={styles.NotificationModelMask}
    >
      <NotificationBody setShowModel={setShowModel} />
    </Sidebar>
  );
}
